import React, { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import TrancheContractABI from "../../../abis/macrostrategytranche.abi.json";
import { useReadContract } from "wagmi";
import { formatUnits } from "viem";
import { TOKEN_SYMBOL } from "../../../utils/constants";

interface TrancheCardProps {
  setActiveTranche: (tranche: number) => void;
  tranche: {
    id: number
    name: string;
    address: string;
    rewards: string;
    minContribution: number;
    status: string;
  }
}

const TrancheCard: React.FC<TrancheCardProps> = ({ setActiveTranche, tranche }) => {
  // Read the allowance and refetch on demand
  const { data: maxCap } = useReadContract({
    abi: TrancheContractABI,
    address: tranche.address as any,
    functionName: "maxCap",
    args: [],
  });

  const { data: totalDeposits } = useReadContract({
    abi: TrancheContractABI,
    address: tranche.address as any,
    functionName: "totalDeposits",
    args: [],
  });

  const percentageCompleted = useMemo(() => {
    if (totalDeposits && maxCap) {
      return Number(formatUnits(totalDeposits as any ?? "0", 18)) / Number(formatUnits(maxCap as any ?? "0", 18)) * 100;
    }
    return 0;
  }, [totalDeposits, maxCap]);

  return (
    <div className="sc-ad7d017b-3 FesdR" onClick={() => setActiveTranche(1)}>
      <h3 className="sc-ad7d017b-4 kgcHyO">{tranche.name}</h3>
      <div className="sc-ad7d017b-5 jVpAm">
        <span className="sc-43f175b-1 jfHdxH">Reward Asset</span>
        <span className="sc-43f175b-2 kAnXpP">ETH</span>
      </div>
      <div className="sc-ad7d017b-5 jVpAm">
        <span className="sc-43f175b-1 jfHdxH">Minimum contribution</span>
        <span className="sc-43f175b-2 kAnXpP">{tranche.minContribution} {TOKEN_SYMBOL}</span>
      </div>
      <div className="sc-ad7d017b-7 fmVvKb">
        <div className="sc-ad7d017b-8 ffuncr">
          <span className="sc-43f175b-1 jfHdxH">
            Cap: {totalDeposits ? Number(formatUnits(totalDeposits as any ?? "0", 18)).toLocaleString("en-US") : "-"} {TOKEN_SYMBOL} / {maxCap ? Number(formatUnits(maxCap as any ?? "0", 18)).toLocaleString("en-US") : "-"} {TOKEN_SYMBOL}
          </span>
        </div>
        <div className="sc-ad7d017b-9 crUHFC">
          <div className="sc-ad7d017b-10 hHItfN" style={{width: percentageCompleted+"%"}} />
        </div>
      </div>
    </div>
  );
}
export default TrancheCard;